"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const models_1 = require("../js/models");
const offCountTypes_1 = __importDefault(require("./offCountTypes"));
//As of 4-28-23, we count different off day slot types at the row level using two categories, pto and vacation.
const offTypes = Object.freeze({
    [models_1.SLOT_TYPES.OFF_DAY]: offCountTypes_1.default.VACATION,
    [models_1.SLOT_TYPES.PTO]: offCountTypes_1.default.PTO,
    //4 is Section rest and is not used in summary stats as of 4-28-23.
    [models_1.SLOT_TYPES.HALF_PTO]: offCountTypes_1.default.PTO,
    [models_1.SLOT_TYPES.PUBLIC_HOLIDAY]: offCountTypes_1.default.VACATION,
    [models_1.SLOT_TYPES.OTHER_HOLIDAY]: offCountTypes_1.default.VACATION,
    [models_1.SLOT_TYPES.KOT_PTO]: offCountTypes_1.default.PTO,
    [models_1.SLOT_TYPES.KOT_HALF_PTO_AM]: offCountTypes_1.default.PTO,
    [models_1.SLOT_TYPES.KOT_HALF_PTO_PM]: offCountTypes_1.default.PTO,
    //103 is KOT Hourly PTO. It is not used in summary stats as of 4-28-23.
});
exports.default = offTypes;
